import { useRef } from "react";
import PropTypes from "prop-types";
import { XmarkSolidV6, Upload } from "@shared/v2/Icomoon";
import IconButton from "@shared/v2/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-regular-svg-icons";
import Button from "@shared/v2/Button/Button";
import { formatFileSize } from "../../../../PersonDetail/actions/helper";

const AdditionalDocument = ({
  handleDocumentUpload,
  uploadedFiles,
  handleFileDrop,
  handleFileReplace,
  handleFileDelete,
  onAdditinalFilePreview,
}) => {
  const hiddenUploadInput = useRef(null);

  return (
    <div>
      <div className="tw-pb-[9px] tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-50">
        <span className="tw-capitalize">Additional Documents (optional)</span>
      </div>
      {uploadedFiles.length > 0 && (
        <div>
          {uploadedFiles.map((uploadedFile, index) => (
            <div
              key={index}
              className="tw-border-solid tw-bg-[#FFFFFF] tw-border-neutral-gray-10 tw-w-[552px] tw-mb-[8px] !tw-py-[13px] tw-px-15px tw-border tw-rounded-4px"
            >
              <div className="!tw-flex tw-grid tw-grid-cols-6 tw-gap-[16px] tw-justify-between tw-h-[33px]">
                <div className="tw-col-start-1 tw-col-span-1">
                  <div className="tw-flex">
                    <FontAwesomeIcon
                      className="tw-text-teal tw-h-[32px] tw-w-[24px] tw-pr-[16px] tw-mb-12px tw-text-24px "
                      icon={faFileAlt}
                    />
                    <div className="tw-m-0 tw-mb-4px tw-text-12d tw-font-normal tw-text-gray-75 tw-max-w-[280px] tw-truncate">
                      {uploadedFile.name}
                      <br />
                      <span className="tw-m-0 tw-mb-4px tw-text-12d tw-font-normal tw-text-gray-50">
                        {formatFileSize(uploadedFile.size)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tw-col-end-8 tw-col-span-1 tw-pt-[4px]">
                  <input
                    type="file"
                    id={`file-input-${index}`}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileReplace(index, e.target.files[0])}
                  />
                  <Button size="small" schema="tertiary" onClick={() => onAdditinalFilePreview(index)}>
                    Preview
                  </Button>
                  <Button
                    className="tw-ml-[8px]"
                    size="small"
                    schema="secondary"
                    onClick={() => document.getElementById(`file-input-${index}`).click()}
                  >
                    replace
                  </Button>
                  <IconButton
                    className="tw-ml-[8px]"
                    schema="tertiary"
                    size="small"
                    onClick={() => handleFileDelete(index)}
                  >
                    <XmarkSolidV6 size="m" />
                  </IconButton>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div
        className="tw-border-gray-15 tw-border-dashed tw-bg-[#FAFAFA] tw-w-[552px] tw-mb-24px !tw-py-[13px] tw-px-15px tw-border tw-rounded-4px"
        data-cy="additional-documents-upload"
        onDrop={handleFileDrop}
        onDragOver={(event) => event.preventDefault()}
      >
        <input
          id="AdditionalDocumentUploadInput"
          type="file"
          multiple
          ref={hiddenUploadInput}
          onChange={handleDocumentUpload}
          style={{ display: "none" }}
        />
        <div className="!tw-flex tw-grid tw-grid-cols-6 tw-gap-[16px] tw-justify-between tw-h-[33px]">
          <div className="tw-col-start-1 tw-col-span-1">
            <div className="tw-flex">
              <FontAwesomeIcon
                className="tw-text-neutral-gray-30 tw-h-[32px] tw-w-[24px] tw-pr-[16px] tw-mb-12px tw-text-24px "
                icon={faFileAlt}
              />
              <div className="tw-m-0 tw-mb-4px tw-text-12d tw-font-normal tw-text-gray-75">
                Drop your file here, or select from computer
                <br />
                <span className="tw-m-0 tw-mb-4px tw-text-12d tw-font-normal tw-text-gray-50">
                  (File Size Limit 15MB)
                </span>
              </div>
            </div>
          </div>
          <div className="tw-col-end-8 tw-col-span-1 tw-pt-[4px]">
            <label htmlFor="AdditionalDocumentUploadInput">
              <Button size="small" schema="secondary" onClick={() => hiddenUploadInput.current?.click()}>
                <Upload size="m" />
                {"   upload"}
              </Button>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

AdditionalDocument.propTypes = {
  handleDocumentUpload: PropTypes.func,
  handleFileDrop: PropTypes.func,
  uploadedFiles: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, size: PropTypes.number })),
};
AdditionalDocument.defaultProps = {
  handleDocumentUpload: () => {},
  handleFileDrop: () => {},
  uploadedFiles: [],
};
export default AdditionalDocument;
